export default {
  questionLabelSize: 16,
  questionPlaceholderSize: 16,
  questionHeaderSize: 16,
  guideTextSize: 14,
}
